import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class GameModeNames extends GameMode {
    public static NORMAL_AVALANCHE: string = "NORMAL_AVALANCHE";
    public static FREESPIN_AVALANCHE: string = "FREESPIN_AVALANCHE";
    public static MAYHEM: string = "MAYHEM";
    public static SUPER_FREESPIN: string = "SUPER_FREESPIN";
}